import { useMemo, Fragment } from 'react';
import { avoidBreakInside } from '@provider/print';
import { ContinueArrowIcon } from '@ui/kit';
import { sequenceTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../../state/hook.entry.js';
import { SequenceInput } from '../input.content.js';
import { orderInputs } from '../util.order-inputs.js';
import { wrapper, circuit, item, tokens, getPointOnCircle } from './container.print.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function CircuitPrintContainer(props) {
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sequenceTileInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  const amountOfItems = userOrderedInputs.length * 2;
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    children: /*#__PURE__*/jsx("div", {
      className: circuit,
      ...avoidBreakInside(),
      children: userOrderedInputs.map((input, index) => /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("div", {
          className: item,
          style: tokens.__override({
            offset: index * 2 / amountOfItems,
            pointX: getPointOnCircle(index * 2 / amountOfItems).x,
            pointY: getPointOnCircle(index * 2 / amountOfItems).y
          }),
          children: /*#__PURE__*/jsx(SequenceInput, {
            node: input,
            taskEntryKey: props.taskEntryKey
          })
        }), /*#__PURE__*/jsx("div", {
          className: item,
          style: tokens.__override({
            offset: (index * 2 + 1) / amountOfItems,
            pointX: getPointOnCircle((index * 2 + 1) / amountOfItems).x,
            pointY: getPointOnCircle((index * 2 + 1) / amountOfItems).y
          }),
          children: /*#__PURE__*/jsx(ContinueArrowIcon, {
            height: 20
          })
        })]
      }, input.id))
    })
  });
}

export { CircuitPrintContainer };
//# sourceMappingURL=container.print.js.map
